import {Component, Input} from '@angular/core';
import {AbstractDialogComponent} from '@wba-ui-module/components/dialogs/abstract-dialog.component';

@Component({
    selector: 'wba-technischer-fehler-dialog',
    templateUrl: './technischer-fehler-dialog.component.html',
    styleUrls: ['./technischer-fehler-dialog.component.scss'],
    standalone: false
})
export class TechnischerFehlerDialogComponent extends AbstractDialogComponent {


  @Input() headerTitle = ' Technischer Fehler';
  @Input() targetId = 'TechnischerFehlerModalDialog';

  constructor() {
    super();
  }

}
